import React from 'react'
import { Spin } from 'antd'
import {
  UnorderedListOutlined,
  GlobalOutlined
} from '@ant-design/icons'
import { Color } from '../../../Common/Color'
import BoxList from '../Common/BoxList'
import BoxMap from '../Common/BoxMap'
import BoxListHeader from '../Common/BoxListHeader'
import MobileBoxCard from './MobileBoxCard'

const inactiveStyle = {
  backgroundColor: Color.dark_blue,
  color: Color.white,
  fontSize: '2em',
  padding: '0.5em'
}

const activeStyle = {
  backgroundColor: Color.white,
  color: Color.dark_blue,
  fontSize: '2em',
  padding: '0.5em'
}

export default function MobileBoxListPage ({
  boxes, nearestBoxes, currentBox, setCurrentBox, lat, long, textList, loading, tabActive, setTabActive
}) {
  return (
    <div style={{ gap: '1em', height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: Color.white }}>
      <BoxListHeader lat={lat} long={long} />
      <>
        <div style={{ backgroundColor: Color.dark_blue }}>
          <UnorderedListOutlined style={tabActive === 'list' ? activeStyle : inactiveStyle} onClick={() => { setTabActive('list') }} />
          <GlobalOutlined style={tabActive === 'map' ? activeStyle : inactiveStyle} onClick={() => { setTabActive('map') }} />
        </div>
        <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>{textList}</div>
        {tabActive === 'list' &&
          <Spin spinning={loading}>
            <BoxList boxes={nearestBoxes} currentBox={currentBox} setCurrentBox={setCurrentBox} BoxCard={MobileBoxCard} />
          </Spin>
        }
        {tabActive === 'map' &&
          <BoxMap currentBox={currentBox} setCurrentBox={setCurrentBox} boxes={boxes} lat={lat} long={long} BoxCard={MobileBoxCard} />
        }
      </>
    </div>
  )
}
